/*
 * Author M. Atoar Rahman
 * Title: Current Stock By Date - Consolidated
 * Description: Flat one-row-per-drug table for the consolidated report
 */

import useDataTable from '../../../hooks/useDataTable';

export default function ConsolidatedDataTable({ data }) {
    const locationOf = (item) =>
        item?.warehouse_name
            ? item.warehouse_name
            : item?.facility_name
            ? item.facility_name
            : item?.partner_name
            ? item.partner_name
            : item?.dispensary_name
            ? item.dispensary_name
            : '';

    const columns = [
        {
            name: <span className="ps-2">Item Name</span>,
            cell: (row) => <span className="ps-2">{row.drug_name}</span>,
            sortable: true,
            wrap: true,
            width: '320px',
            fixed: true,
            style: { borderBottom: '1px solid #ddd' },
        },
        {
            name: 'Code No',
            cell: (row) => <span className="ps-2">{row.code_no}</span>,
            sortable: true,
            width: '150px',
        },
        {
            name: 'Available Qty',
            cell: (row) => <span className="ps-2">{row.available_qty}</span>,
            sortable: true,
            width: '150px',
        },
        {
            name: 'Location From',
            cell: (row) => <span className="ps-2">{locationOf(row)}</span>,
            sortable: true,
            wrap: true,
            width: '220px',
        },
    ];

    return useDataTable({ columns, data, pagination: false });
}
